import Layout from "layout";
import BehsaLandingLayout from "layout/landings/behsa";
import IBehsaPageConfig from "rules/interface/config/behsa-config.interface";
import IPageConfig from "rules/interface/config/config.interface";




// behsa landing page path on "/landings/behsa" url
export const BehsaLandingPageConfig: IBehsaPageConfig = {
    layout: BehsaLandingLayout,
    config: {}
};

export const InstallmentLandingPageConfig: IPageConfig = {
    layout: Layout,
    config: {
        footer: {
            hide: true
        },
        header: {
            onlyLogo: true,
            hideMenu: true,
            unlinkLogo: true
        }
    }
};

export const InstallerLandingPageConfig: IPageConfig = {
    layout: Layout,
    config: {}
};